import React, { Fragment, FunctionComponent, useEffect } from "react";

export type LocalizationLoaderComponentProps = {
    /** Funkce, jejíž volání zajistí načtení lokalizací */
    loadLocalizations: () => void;
    /** Příznak, zda jsou lokalizace načtené */
    localizationsLoaded: boolean;
};

/**
 * Obalující komponenta, která zajistí načtení lokalizací, pokud ještě nejsou načtené. To se provádí typicky při _namountování_ komponenty.
 * Komponenta vykresluje pouze zadané potomky, sama o sobě žádné elementy nepřidává.
 */
export const LocalizationLoaderComponent: FunctionComponent<LocalizationLoaderComponentProps> = ({
    loadLocalizations,
    localizationsLoaded,
    children,
}) => {
    useEffect(() => {
        if (!localizationsLoaded) {
            loadLocalizations();
        }
    }, [loadLocalizations, localizationsLoaded]);
    return (
        <Fragment>
            {children}
        </Fragment>
    );
};
